// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2gQkG","card":"Cards_card__3oAUD","infected":"Cards_infected__1UZb7","recovered":"Cards_recovered__3y817","deaths":"Cards_deaths__1bogj"};